// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/img_qrconde.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/phone_icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact {
    background: #111720;
    padding: 0.26042rem 0;
}
.contact-wrap {
    width: 7.29167rem;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    flex-wrap: wrap;
}
.contact-address {
    color: #6F7783;
    font-size: 0.125rem;
}
.contact-ercode {
    text-align: center;
    width: 0.83333rem;
    font-size: 0.10417rem;
    color:#ACB3BF;
}
.contact-ercode-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: 0.83333rem;
    height: 0.83333rem;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 0.05208rem;
}
.contact-phone {
    padding: 0 0.10417rem;
}

.contact-phone-number-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    width: 0.1875rem;
    height: 0.1875rem;
    display: inline-block;
    background-repeat:  no-repeat;
    background-size: contain;
    vertical-align: sub;
}
.contact-phone-number-value {
    font-size:0.1875rem;
    font-family: 'BakbakOne';
    color: #2475EE;
    margin-left: 0.10417rem;
    display: inline-block;
    font-weight: 400;
    letter-spacing: 0.03125rem;
}
.contact-address-map {
    width: 3.38021rem;
    height: 1.29167rem;
    background-color: #fff;
}

@media screen and (max-width: 700px) {
    .contact-wrap {
        width: 9.375rem;
    }
    .contact-ercode {
        width: 1.51042rem;
        margin-bottom: 0.26042rem;
    }
    .contact-ercode-icon {
        width: 1.5625rem;
        height: 1.5625rem;
    }
    .contact-ercode p {
        font-size: 0.14583rem;
    }
    .contact-phone {
        width: 7.29167rem;
        margin-bottom: 0.26042rem;
    }
    .contact-phone-number {
        display: flex;
        justify-content: start;
        align-items: center;
    }
    .contact-phone-number-value {
        font-size: 0.36458rem;

    }
    .contact-address {
        font-size: 0.25rem;
        margin-top:0.10417rem;
    }
    .contact-phone-number-icon {
        width: 0.45833rem;
        height: 0.45833rem;
    }
    .contact-address-map {
        width: 100%;
        height: 3.125rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Contact/Contact.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,qBAAiB;AACrB;AACA;IACI,iBAAa;IACb,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,cAAc;IACd,mBAAe;AACnB;AACA;IACI,kBAAkB;IAClB,iBAAY;IACZ,qBAAe;IACf,aAAa;AACjB;AACA;IACI,yDAA4D;IAC5D,iBAAY;IACZ,kBAAa;IACb,cAAc;IACd,4BAA4B;IAC5B,wBAAwB;IACxB,yBAAmB;AACvB;AACA;IACI,qBAAiB;AACrB;;AAEA;IACI,yDAA2D;IAC3D,gBAAW;IACX,iBAAY;IACZ,qBAAqB;IACrB,6BAA6B;IAC7B,wBAAwB;IACxB,mBAAmB;AACvB;AACA;IACI,mBAAc;IACd,wBAAwB;IACxB,cAAc;IACd,uBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,0BAAmB;AACvB;AACA;IACI,iBAAY;IACZ,kBAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI;QACI,eAAa;IACjB;IACA;QACI,iBAAY;QACZ,yBAAmB;IACvB;IACA;QACI,gBAAY;QACZ,iBAAa;IACjB;IACA;QACI,qBAAe;IACnB;IACA;QACI,iBAAa;QACb,yBAAmB;IACvB;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,qBAAe;;IAEnB;IACA;QACI,kBAAe;QACf,qBAAe;IACnB;IACA;QACI,iBAAW;QACX,kBAAY;IAChB;IACA;QACI,WAAW;QACX,gBAAa;IACjB;AACJ","sourcesContent":[".contact {\n    background: #111720;\n    padding: 50px 0px;\n}\n.contact-wrap {\n    width: 1400px;\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    text-align: left;\n    flex-wrap: wrap;\n}\n.contact-address {\n    color: #6F7783;\n    font-size: 24px;\n}\n.contact-ercode {\n    text-align: center;\n    width: 160px;\n    font-size: 20px;\n    color:#ACB3BF;\n}\n.contact-ercode-icon {\n    background-image: url('../../assets/images/img_qrconde.png');\n    width: 160px;\n    height: 160px;\n    margin: 0 auto;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin-bottom: 10px;\n}\n.contact-phone {\n    padding: 0px 20px;\n}\n\n.contact-phone-number-icon {\n    background-image: url('../../assets/images/phone_icon.svg');\n    width: 36px;\n    height: 36px;\n    display: inline-block;\n    background-repeat:  no-repeat;\n    background-size: contain;\n    vertical-align: sub;\n}\n.contact-phone-number-value {\n    font-size:36px;\n    font-family: 'BakbakOne';\n    color: #2475EE;\n    margin-left: 20px;\n    display: inline-block;\n    font-weight: 400;\n    letter-spacing: 6px;\n}\n.contact-address-map {\n    width: 649px;\n    height: 248px;\n    background-color: #fff;\n}\n\n@media screen and (max-width: 700px) {\n    .contact-wrap {\n        width: 1800px;\n    }\n    .contact-ercode {\n        width: 290px;\n        margin-bottom: 50px;\n    }\n    .contact-ercode-icon {\n        width: 300px;\n        height: 300px;\n    }\n    .contact-ercode p {\n        font-size: 28px;\n    }\n    .contact-phone {\n        width: 1400px;\n        margin-bottom: 50px;\n    }\n    .contact-phone-number {\n        display: flex;\n        justify-content: start;\n        align-items: center;\n    }\n    .contact-phone-number-value {\n        font-size: 70px;\n\n    }\n    .contact-address {\n        font-size: 48px;\n        margin-top:20px;\n    }\n    .contact-phone-number-icon {\n        width: 88px;\n        height: 88px;\n    }\n    .contact-address-map {\n        width: 100%;\n        height: 600px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
